import { render, staticRenderFns } from "./StaffSingle.vue?vue&type=template&id=22fa276d&"
import script from "./StaffSingle.vue?vue&type=script&lang=js&"
export * from "./StaffSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports